import http from '../http'

export default {
  // 上传埋点
  uploadEt(data: object) {
    return http.post('/kp-server-et/et/upload_et_data_post', data, {
      showMessage: false,
    })
  },
}
